import api from '@/lib/api';
import type { AdminOverview } from '@/types/admin';

export async function fetchOverview(): Promise<AdminOverview> {
  const { data } = await api.get<{ data: AdminOverview }>('/admin/overview');
  return data.data;
}
